import PropTypes from "prop-types"
import styled from "styled-components"
import Icon from "components/icons/icon"
import Arrow from "components/icons/arrow"

const Button = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  cursor: pointer;
  ${({ side }) => `${side}: -25px;`}
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;

  &[disabled] {
    opacity: 0;
    transition: opacity 0.2s 0.6s;
  }
`

const StyledIcon = styled(Icon)`
  transform: rotate(${({ side }) => (side === "left" ? "180deg" : "0")});
`

function SliderArrow({ side, handleClick, disabled, className }) {
  return (
    <Button side={side} onClick={handleClick} disabled={disabled} className={className}>
      <StyledIcon Icon={Arrow} side={side} color="deepPink" />
    </Button>
  )
}

SliderArrow.defaultProps = {
  className: null,
  disabled: false
}

SliderArrow.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  handleClick: PropTypes.func.isRequired,
  side: PropTypes.oneOf(["left", "right"]).isRequired
}

export default SliderArrow
